// src/components/ApprovalPanel.jsx
import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";

export default function ApprovalPanel() {
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Fetch pending submissions on mount
  useEffect(() => {
    fetchSubmissions();
    // eslint-disable-next-line
  }, []);

  async function fetchSubmissions() {
    setLoading(true);
    setError("");
    const { data, error } = await supabase
      .from("gallery-submissions")
      .select("*")
      .eq("status", "pending")
      .order("created_at", { ascending: false });

    if (error) setError("Error loading submissions: " + error.message);
    setSubmissions(data || []);
    setLoading(false);
  }

  async function handleAction(id, newStatus) {
    setLoading(true);
    setError("");
    const { error } = await supabase
      .from("gallery-submissions")
      .update({ status: newStatus })
      .eq("id", id);

    if (error) {
      setError("Error updating status: " + error.message);
    } else {
      setSubmissions(submissions => submissions.filter(s => s.id !== id));
    }
    setLoading(false);
  }

  return (
    <div style={{
      maxWidth: 750, margin: "2rem auto", padding: 36,
      background: "#fbf8ff", borderRadius: 32, boxShadow: "0 2px 18px #cfc3f7aa"
    }}>
      <h2 style={{ color: "#8854e6", textAlign: "center", marginBottom: 28, fontSize: 38 }}>
        Pending Gallery Submissions
      </h2>

      {error && <div style={{ color: "#be1fd7", marginBottom: 16, fontWeight: 500 }}>{error}</div>}
      {loading && <div>Loading...</div>}
      {!loading && submissions.length === 0 && (
        <div style={{ textAlign: "center", color: "#444", fontSize: 22, marginTop: 30 }}>
          No pending submissions!
        </div>
      )}

      {submissions.map(submission => (
        <div
          key={submission.id}
          style={{
            background: "#f6f2ff", borderRadius: 24, marginBottom: 32, padding: 22, boxShadow: "0 1px 5px #eee"
          }}
        >
          <div style={{ fontWeight: 700, color: "#6d3dc6", fontSize: 25, marginBottom: 2 }}>
            {submission.publicName || submission.name || "Anonymous"}
            <span style={{
              fontWeight: 400,
              color: "#888",
              marginLeft: 8,
              fontSize: 16,
            }}>
              ({new Date(submission.created_at).toLocaleString()})
            </span>
          </div>
          <div style={{ fontSize: 20, color: "#8854e6", marginBottom: 12 }}>
            {submission.caption}
          </div>
          {/* FILES SECTION */}
          <div style={{ marginBottom: 12 }}>
            {Array.isArray(submission.files) && submission.files.length > 0 ? (
              submission.files.map((file, idx) =>
                file.type === "image" ? (
                  <a
                    href={file.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    key={file.url + idx}
                    style={{ display: 'inline-block', marginRight: 10, marginBottom: 8 }}
                  >
                    <img
                      src={file.url}
                      alt={file.name}
                      style={{
                        width: 110,
                        height: "auto",
                        borderRadius: 7,
                        border: "1.5px solid #cfc3f7",
                        background: "#fff"
                      }}
                    />
                  </a>
                ) : (
                  <a
                    href={file.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    key={file.url + idx}
                    style={{
                      display: "inline-block",
                      marginRight: 10,
                      marginBottom: 8,
                      color: "#5522bb",
                      textDecoration: "underline",
                      fontSize: 15,
                      fontWeight: 600
                    }}
                  >
                    {file.name}
                  </a>
                )
              )
            ) : (
              <div style={{ color: "#aaa" }}>No files submitted.</div>
            )}
          </div>
          {/* ACTION BUTTONS */}
          <div>
            <button
              style={{
                background: "#7ee081",
                color: "#22622e",
                border: "none",
                borderRadius: 10,
                fontWeight: 700,
                fontSize: 26,
                padding: "8px 32px",
                marginRight: 16,
                boxShadow: "0 2px 8px #b0f3ca22"
              }}
              onClick={() => handleAction(submission.id, "approved")}
              disabled={loading}
            >
              Approve
            </button>
            <button
              style={{
                background: "#ed5d8d",
                color: "#fff",
                border: "none",
                borderRadius: 10,
                fontWeight: 700,
                fontSize: 26,
                padding: "8px 32px",
                boxShadow: "0 2px 8px #f5b8d522"
              }}
              onClick={() => handleAction(submission.id, "rejected")}
              disabled={loading}
            >
              Reject
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
